import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import banner from "../../../assets/images/vitamin/bannerv.jpg";
import { BiChevronsRight } from "react-icons/bi";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";
import img1 from "../../../assets/images/vitamin/a.png";
import img2 from "../../../assets/images/vitamin/b1.png";
import img3 from "../../../assets/images/vitamin/b2.png";
import img4 from "../../../assets/images/vitamin/b3.png";
import img5 from "../../../assets/images/vitamin/b5.png";
import img6 from "../../../assets/images/vitamin/b6.png";
import img7 from "../../../assets/images/vitamin/b7.png";
import img8 from "../../../assets/images/vitamin/b9.jpg";
import img9 from "../../../assets/images/vitamin/B12.png";
import img10 from "../../../assets/images/vitamin/c.png";
import img11 from "../../../assets/images/vitamin/d.png";
import img12 from "../../../assets/images/vitamin/e.png";
import img13 from "../../../assets/images/vitamin/k.png";

const VitaminsAreNecessary = () => {
  return (
    <Container>
      <TopServiceBanner title=" Vitamins" banner={banner} />
      <Inner>
        <Title>What are vitamins, and how do they work?</Title>
        <SubTitle>
          Vitamins are organic compounds that people need in small quantities.
          Most vitamins need to come from food because the body either does not
          produce them or produces very little.
          <br />
          Each organism has different vitamin requirements. For example, humans
          need to get vitamin C from their diets — while dogs can produce all
          the vitamin C that they need. For humans, vitamin D is not available
          in large enough quantities in food. The human body synthesizes the
          vitamin when exposed to sunlight, and this is the best source of
          vitamin D. Different vitamins play different roles in the body, and a
          person requires a different amount of each vitamin to stay healthy.
          <br />
          <br />
          This article explains what vitamins are, what they do, and which foods
          are good sources.
        </SubTitle>

        <Title>What are vitamins?</Title>
        <SubTitle>
          Vitamins are organic substances present in minute amounts in natural
          foodstuffs. Having too little of any particular vitamin may increase
          the risk of developing certain health issues. A vitamin is an organic
          compound, which means that it contains carbon. It is also an essential
          nutrient that the body may need to get from food. There are currently
          13 recognized vitamins.
        </SubTitle>
        <Title>The 13 vitamins</Title>
        <SubTitle>
          Below, learn about each currently recognized vitamin:
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin A
                <MiddleSubTitle>
                  <b> Chemical names: </b>retinol, retinal, and “the four
                  carotenoids,” including beta carotene.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is fat-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Function:</b> It is essential for eye health.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Deficiency:</b> This may cause night blindness and
                  keratomalacia, which causes the clear front layer of the eye
                  to grow dry and cloudy.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include liver, cod liver oil,
                  carrots, broccoli, sweet potatoes, butter, kale, spinach,
                  pumpkins, collard greens, some cheeses, eggs, apricots,
                  cantaloupe melon, and milk.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img1} alt="A" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>
        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin B1
                <InvertedMiddleSubTitle>
                  <b> Chemical name: </b>thiamine.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is water-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Function:</b> It is essential for producing various
                  enzymes that help break down blood sugar.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Deficiency:</b> This may cause beriberi and
                  Wernicke-Korsakoff syndrome.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include yeast, pork, cereal
                  grains, sunflower seeds, brown rice, whole grain rye,
                  asparagus, kale, cauliflower, potatoes, oranges, liver, and
                  eggs.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img2} alt="B1" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin B2
                <MiddleSubTitle>
                  <b> Chemical names: </b>riboflavin.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is water-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Function: </b>It is essential for the growth and
                  development of body cells and helps metabolize food.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Deficiency:</b> Symptoms include inflammation of the lips
                  and fissures in the mouth.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include asparagus, bananas,
                  persimmons, okra, chard, cottage cheese, milk, yogurt, meat,
                  eggs, fish, and green beans.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img3} alt="B2" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin B3
                <InvertedMiddleSubTitle>
                  <b> Chemical names: </b>niacin, niacinamide.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is water-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Function:</b> The body needs niacin for the cells to grow
                  and work correctly.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b>Deficiency: </b> Low levels result in a health issue called
                  pellagra, which causes diarrhea, skin changes, and intestinal
                  upset.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Good sources:</b> Examples include chicken, beef, tuna,
                  salmon, milk, eggs, tomatoes, leafy vegetables, broccoli,
                  carrots, nuts and seeds, tofu, and lentils.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img4} alt="B3" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin B5
                <MiddleSubTitle>
                  <b> Chemical names: </b> pantothenic acid.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is water-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Function:</b> It is necessary for producing energy and
                  hormones.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Deficiency:</b> Symptoms include paresthesia, or “pins and
                  needles.”
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include meats, whole grains,
                  broccoli, avocados, and yogurt.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img5} alt="B5" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin B6
                <InvertedMiddleSubTitle>
                  <b> Chemical names: </b>pyridoxine, pyridoxamine, pyridoxal.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is water-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Function: </b>It is vital for the formation of red blood
                  cells.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Deficiency:</b> Low levels may lead to anemia and
                  peripheral neuropathy.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include chickpeas, beef liver,
                  bananas, squash, and nuts.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img6} alt="B6" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin B7
                <MiddleSubTitle>
                  <b> Chemical name:</b> biotin.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is water-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b>Function:</b> It enables the body to metabolize proteins,
                  fats, and carbohydrates. It also contributes to keratin, a
                  structural protein in the skin, hair, and nails.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Deficiency:</b> Low levels may cause dermatitis or
                  inflammation of the intestines.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Good sources: </b>These include egg yolk, liver, broccoli,
                  spinach, and cheese.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img7} alt="B7" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin B9
                <InvertedMiddleSubTitle>
                  <b> Chemical names:</b> folic acid, folinic acid.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is water-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Functions:</b> It is essential for making DNA and RNA.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Deficiency: </b>During pregnancy, this can affect the
                  fetus’s nervous system. Doctors recommend folic acid
                  supplements before and during pregnancy.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                  <b> Good sources:</b> These include leafy vegetables, peas,
                  legumes, liver, some fortified grain products, and sunflower
                  seeds. Also, several fruits have moderate amounts.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img8} alt="B9" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin B12
                <MiddleSubTitle>
               <b> Chemical names: </b>cyanocobalamin, hydroxocobalamin, methylcobalamin.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is water-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                  <b> Function:</b> It is essential for a healthy nervous system.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Deficiency:</b> Low levels may lead to neurological problems and some types of anemia.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Good sources: </b>Examples include fish, shellfish, meat, poultry, eggs, milk and other dairy products, fortified cereals, fortified soy products, and fortified nutritional yeast.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img9} alt="B12" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin C
                <InvertedMiddleSubTitle>
               <b> Chemical name:</b> ascorbic acid.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is water-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
               <b>   Function: </b>It contributes to collagen production, wound healing, and bone formation. It also strengthens blood vessels, supports the immune system, helps the body absorb iron, and acts as an antioxidant.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                 <b> Deficiency: </b>This may result in scurvy, which causes bleeding gums, a loss of teeth, and poor tissue growth and wound healing.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                 <b> Good sources:</b> These include fruit and vegetables, but cooking destroys vitamin C.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img10} alt="C" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin D
                <MiddleSubTitle>
               <b> Chemical names: </b>ergocalciferol, cholecalciferol.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is fat-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Function:</b> It is necessary for the healthy mineralization of bone.

                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Deficiency:</b> This may cause rickets and osteomalacia, or softening of the bones.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Good sources:</b> Exposure to UVB rays from the sun or other sources causes the body to produce vitamin D. Fatty fish, eggs, beef liver, and mushrooms also contain the vitamin.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img11} alt="D" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <InvertedMiddle>
          <MiddleInner>
            <InvertedMiddleInnerLeft>
              <InvertedMiddleTextLeft>
                Vitamin E
                <InvertedMiddleSubTitle>
               <b> Chemical names: </b>tocopherol, tocotrienol.
                </InvertedMiddleSubTitle>
              </InvertedMiddleTextLeft>
              <Ul>
                <InvertedLi>
                  <BiChevronsRight />
                  It is fat-soluble.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                <b>  Function: </b>Its antioxidant activity helps prevent oxidative stress, an issue that increases the risk of widespread inflammation and various diseases.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                 <b> Deficiency:</b> This is rare, but it may cause hemolytic anemia in newborns. This condition destroys blood cells.
                </InvertedLi>
                <InvertedLi>
                  <BiChevronsRight />
                 <b> Good sources: </b>These include wheat germ, kiwis, almonds, eggs, nuts, leafy greens, and vegetable oils.
                </InvertedLi>
              </Ul>
            </InvertedMiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img12} alt="E" />
            </MiddleInnerRight>
          </MiddleInner>
        </InvertedMiddle>

        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Vitamin K
                <MiddleSubTitle>
               <b> Chemical names: </b>phylloquinone, menaquinone.
                </MiddleSubTitle>
              </MiddleTextLeft>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  It is fat-soluble.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Function:</b> It is necessary for blood clotting.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Deficiency:</b> Low levels may cause an unusual susceptibility to bleeding, or bleeding diathesis.
                </Li>
                <Li>
                  <BiChevronsRight />
                 <b> Good sources:</b> These include natto, leafy greens, pumpkins, figs, and parsley.
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img13} alt="K" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <Title>Vitamin supplements</Title>
        <SubTitle>
          Many people in the United States take multivitamins and other
          supplements, though these may not be necessary or helpful, according
          to researchTrusted Source.
          <br />
          A balanced, varied diet that contains plenty of fruits and vegetables
          should be the primary source of vitamins. The Department of Health and
          Human Services provide up-to-date guidelinesTrusted Source detailing
          the best ways to get enough nutrients from the diet. Fortified foods
          and supplements may be appropriate in some cases, however, such as
          during pregnancy, for people with restricted diets, and for people
          with specific health issues.
          <br />
          <br />
          Anyone taking supplements should be careful not to exceed the maximum
          dose, as researchTrusted Source shows that taking too much of any
          vitamin can lead to health problems. Also, some medications can
          interact with vitamin supplements. Overall, it is important to speak
          with a healthcare provider before trying any supplement.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />
    </Container>
  );
};

export default VitaminsAreNecessary;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 3rem;
  padding-top: 3rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: 3fr 2fr;
  padding: 2rem;

  @media (max-width: 1180px) {
  }
`;

const MiddleInnerLeft = styled.div`
  display: grid;
  gap: 1rem;

  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div``;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  text-align: center;
  display: grid;
  gap: 1rem;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;
const InvertedMiddle = styled.div``;

const InvertedMiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const InvertedMiddleInnerLeft = styled.div`
  display: grid;
  gap: 1rem;

  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;

const InvertedMiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  text-align: center;
  display: grid;
  gap: 1rem;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

const Ul = styled.ul`
  display: grid;
  gap: 1rem;

  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;

const InvertedLi = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;

  @media (max-width: 600px) {
    font-size: 1.1rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const Img = styled.img`
  width: 100%;

  @media (max-width: 1180px) {
    width: 45%;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
